import { useState } from 'react';
import Tooltip from '@/components/Tooltip';
import { Button } from '@music-vine/cadence/ui';
import { Info } from '@music-vine/cadence/icons';
import { Input } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
interface ChannelIDInputProps {
  disabled?: boolean;
  handleSubmitChannelID: (id: string) => void;
}
export const ChannelIDInput: React.FC<ChannelIDInputProps> = ({
  handleSubmitChannelID,
  disabled
}) => {
  const [channelID, setChannelID] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      value
    } = e.target;
    setChannelID(value);
  };
  const channelIDLength = channelID.length;
  return <div className="border-0 py-4" data-sentry-component="ChannelIDInput" data-sentry-source-file="ChannelIDInput.tsx">
      <Text className="text-xs" data-sentry-element="Text" data-sentry-source-file="ChannelIDInput.tsx">Can't find your channel?</Text>
      <Text className="flex items-center text-xs" data-sentry-element="Text" data-sentry-source-file="ChannelIDInput.tsx">
        Enter your channel ID below{' '}
        <Tooltip label="How to find your channel ID?" data-sentry-element="Tooltip" data-sentry-source-file="ChannelIDInput.tsx">
          <Button asChild borderRadius="full" className="m-0 ms-1 mb-0!" disabled={disabled} icon size="xs" variant="transparent" data-sentry-element="Button" data-sentry-source-file="ChannelIDInput.tsx">
            <a aria-label="How to find your channel ID?" href="https://support.google.com/youtube/answer/3250431" rel="noreferrer" target="_blank">
              <Info className="size-4 text-gray-500 dark:text-gray-100" data-sentry-element="Info" data-sentry-source-file="ChannelIDInput.tsx" />
            </a>
          </Button>
        </Tooltip>
      </Text>
      <div className="mt-2 flex flex-auto @[300px]:flex-row flex-col items-center gap-2">
        <div className="relative flex w-full flex-col">
          <Input className="bg-[var(--whitelisting-input-override-bg)]!" disabled={disabled} maxLength={24} onChange={handleChange} placeholder="Channel ID" type="text" value={channelID} data-sentry-element="Input" data-sentry-source-file="ChannelIDInput.tsx" />
        </div>
        <Tooltip className="z-[10000]" label={channelID ? `Please confirm your ID is correct: ${channelID}` : 'Please provide a channel ID'} data-sentry-element="Tooltip" data-sentry-source-file="ChannelIDInput.tsx">
          <Button className="h-9 w-full sm:w-min" disabled={channelIDLength !== 24 || disabled} onClick={() => {
          if (!disabled) {
            handleSubmitChannelID(channelID);
          }
        }} variant="brand" data-sentry-element="Button" data-sentry-source-file="ChannelIDInput.tsx">
            Confirm
          </Button>
        </Tooltip>
      </div>
    </div>;
};